import React, { useState, useEffect, useRef } from 'react'
import Button from '@everlane/button'

// Renders a button with 2 new features:
// When clicked, it is disabled and stays disabled.
// When clicked, it renders timedText for `timeout` ms then reverts back to text
export default function TimedButton({ timeout = 3000, onClick, text, timedText, ...props }) {
  const [buttonClickCount, setButtonClickCount] = useState(0)
  const [isButtonDisabled, setIsButtonDisabled] = useState(false)

  // Duplicates componentDidUpdate
  // Doesn't call setIsShowingTimedText on initial render
  const firstUpdate = useRef(true)
  useEffect(() => {
    if (firstUpdate.current) {
      firstUpdate.current = false
    } else {
      setIsButtonDisabled(true)
      const timer = setTimeout(() => setIsButtonDisabled(false), timeout)
      return () => clearTimeout(timer)
    }
  }, [buttonClickCount, timeout])

  return (
    <Button
      {...props}
      disabled={isButtonDisabled}
      onClick={() => {
        onClick && onClick()
        setButtonClickCount(buttonClickCount + 1)
      }}
    >
      {isButtonDisabled ? timedText : text}
    </Button>
  )
}
